// extracted by mini-css-extract-plugin
module.exports = {"SocialMedia":"socialmedia-module--SocialMedia--m-BBu"};